// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__xF-W2","footer":"Sidebar_footer__uUeBj","copyright":"Sidebar_copyright__VqF4T"};